import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }
const _hoisted_3 = {
  key: 0,
  class: "divide-y divide-catering-cream-300"
}
const _hoisted_4 = { class: "flex items-baseline justify-between gap-2" }
const _hoisted_5 = { class: "min-w-0 truncate font-medium text-catering-ink-900" }
const _hoisted_6 = { class: "shrink-0 tabular-nums text-catering-ink-500" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-catering-ink-500"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "mb-1 text-catering-ink-700" }
const _hoisted_10 = { class: "list-disc pl-4 text-catering-ink-800" }
const _hoisted_11 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_12 = { class: "list-disc pl-4 text-xs text-catering-ink-500" }


export default {
  __name: 'BotSmartlistList',
  props: { block: { type: Object, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.block.lists ? 'Smart lists' : __props.block.name), 1),
    (__props.block.lists)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.lists, (l, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: "py-1.5"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(l.name), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(l.member_count) + " members", 1)
              ]),
              (l.filter_summary)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(l.filter_summary), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(__props.block.member_count) + " members · " + _toDisplayString(__props.block.combine), 1),
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.filters || [], (f, i) => {
              return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(f.plain_english), 1))
            }), 128))
          ]),
          ((__props.block.diagnostics || []).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-[11px] font-semibold uppercase tracking-wide text-catering-honey-600" }, "Why it may be empty", -1)),
                _createElementVNode("ul", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.diagnostics, (d, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(d), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

}